import { getUpgradeEepForLink } from 'src/universal/utils/orchestraUtils';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import isProduction from 'src/universal/utils/isProduction';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

export const getFormattedCtaLinks = ({ originalLinks, pageEep, pznOffer = {} }) => {
  const formattedLinks = (originalLinks || []).map(link => {
    const upgradeEep = getUpgradeEepForLink(link, pznOffer);
    const pznEep = pznOffer.eep;
    const eepToUse = upgradeEep || pznEep || pageEep;
    const { url } = link;
    const amexHost = isProduction()
      ? 'www.americanexpress.com'
      : 'qwww.americanexpress.com';
    const urlWithEep = replaceStringWithVars({
      varsObject: {
        amexHost: amexHost,
        eep: eepToUse
      },
      string: url
    });
    return {
      ...link,
      url: urlWithEep
    };
  });

  return parseArrayToObject(formattedLinks, 'key');
};
